import React from 'react';
import { Route, RouteProps } from 'react-router-dom';

interface IProviderProps {
    children: React.ReactNode
}
interface IRouteProps extends RouteProps {
    providerComponent: ({ children }: IProviderProps) => JSX.Element;
    component: React.ComponentType;
}

export const RouteProvider = ({ providerComponent, component, ...rest }: IRouteProps) => {
    const Provider = providerComponent;
    const Component = component;

    return (
        <Route {...rest}>
            <Provider>
                <Component />
            </Provider>
        </Route>
    );
};
